import './ConfirmationModal.css';
import { useTranslation } from 'react-i18next';
const { Modal, Button } = require('react-bootstrap');

const ConfirmationModal = ({ children, isOpen, setOpen, onConfirm, options = {} }) => {
    const { t } = useTranslation();
    const {
        confirmBtnText = t('confirm'),
        cancelBtnText = t('cancel'),
        center = false,
        header = null,
    } = options;
    return (
        <Modal show={isOpen} onHide={() => setOpen(false)}>
            {header && (
                <Modal.Header className={`${center && 'justify-content-center'}`}>
                    <Modal.Title>{options.header}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body className={`${center && 'd-flex flex-column align-items-center'}`}>
                {children}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                >
                    {confirmBtnText}
                </Button>
                <Button variant="secondary" onClick={() => setOpen(false)}>
                    {cancelBtnText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
